module.exports = function(app) {

    app.controller('pages.forgotPassword.accountRecovery.step2', ["$state", "$scope", '$timeout', '$q', 'userService', 'coremetrics', 'brand', 'aemContent',
        function($state, $scope, $timeout, $q, userService, coremetrics, brand, aemContent) {

            $scope.isMINCR = (brand.current.sharedBrandCode === 'mincr') ? true : false;
            $scope.isNDBCBS = (brand.current.sharedBrandCode === 'ndbcbs') ? true : false;
            $scope.isWYBCBS = (brand.current.sharedBrandCode === 'wybcbs') ? true : false;

            var user = $state.params.user || "";
            if (user === "" || !(user && user.userToken && user.userToken.length > 0)) {
                $scope.$parent.goto(1, false);
            }
           
            var phoneNumber = "the number on the back of your member ID card.";
            if ($scope.brandData.phoneNumbers && $scope.brandData.phoneNumbers.technical) {
                phoneNumber = $scope.brandData.phoneNumbers.technical;
            }

            $scope.maskedUserName = " " + user.userName;
            $scope.maskedEmail = user.email;
            $scope.emailVerified = (user.verified === 1 ? true : false);

            $scope.showOkButton = false;
            $scope.disableButtons = false;
            $scope.disableSubmitButtons = false;

            $scope.user = {
                requestUserName: "",
                resetAccount: ""
            };

            $scope.footerMessage = {
                header: "",
                message: "",
                iconClass: "",
                show: false
            };

            var sendUsernameEmail = function() {
                var deferred = $q.defer();
                userService.sendUsernameEmail(user.userToken).then(
                    function(response) {
                        deferred.resolve(response);
                    },
                    function(error) {
                        var baseMessage = userService.parseBaseMessage(error);

                        if ($scope.user.resetAccount === "no" && baseMessage && baseMessage.returnCode === 412) {
                            // If the error is for a user exceeding the max number of requests, and has selected email only, show specific error message.
                            $scope.showOkButton = true;
                            $scope.disableButtons = false;
                            userService.showFooterMessage($scope.footerMessage, '', '<span data-aem-content="RECOVERY_STEP2_TO_MANY_REQUESTS_TEXT as errorText">{{errorText}}' + ' ' + phoneNumber + '</span>', true);

                            deferred.reject();

                        } else if ($scope.user.resetAccount === "yes" && baseMessage && baseMessage.returnCode === 412) {
                            // If the error is for a user exceeding the max number of requests, and has selected to continue with password reset/unlock, allow them to continue.
                            deferred.resolve(error);

                        } else if (baseMessage && baseMessage.returnCode === 404) {
                            var context = (baseMessage.businessContext && baseMessage.businessContext.length > 0) ? baseMessage.businessContext : 'UNKNOWN_404';
                            deferred.reject();
                            $scope.$parent.goto(1, false, { error: { code: baseMessage.returnCode, context: context } });

                        } else {
                            showGeneralErrorMessage();
                            deferred.reject();
                        }
                    }
                );
                return deferred.promise;
            };

            $scope.nextStep = function() {
                if($scope.isMINCR || $scope.isNDBCBS || $scope.isWYBCBS){
                    $scope.recoveryOptionsForm.$valid=true;
                    $scope.user.requestUserName = ($scope.user.requestUserName==""|"false")?"no":"yes";
                    $scope.user.resetAccount = ($scope.user.resetAccount==""|"false")?"no":"yes";
                }
                if ($scope.recoveryOptionsForm.$valid) {
                    $scope.disableButtons = true;

                    if ($scope.user.requestUserName === "yes" && $scope.user.resetAccount === "no") {
                        // Email username only.
                        sendUsernameEmail().then(function(response) {
                            $scope.showOkButton = true;
                            $scope.disableButtons = false;
                            userService.showFooterMessage($scope.footerMessage, "", '<span data-aem-content="RECOVERY_STEP2_EMAIL_SENT_MSG"></span>', false);
                        });

                    } else if ($scope.user.requestUserName === "yes" && $scope.user.resetAccount === "yes") {
                        // Email username then continue with recovery.
                        sendUsernameEmail().then(function(response) {
                            $scope.$parent.goto(3, true, { user: user, emailResponse: response });
                        });

                    } else if ($scope.user.requestUserName === "no" && $scope.user.resetAccount === "yes") {
                        // Recovery only, go to step3.
                        $scope.$parent.goto(3, true, {user : user});

                    } else {
                        $scope.$parent.goto(1, false);
                    }

                    // Finish Step 2 conversion event
                    coremetrics.finishConversion('STEP 2 SELECT USERNAME/PASSWORD/ACCOUNT', 'SPLASH PAGE FORGOT USERNAME OR PASSWORD');
                }
            };

            $scope.backButton = function() {
                $scope.$parent.goto(1, false);
            };

            $scope.okButton = function() {
                // Finish whole flow conversion event
                coremetrics.finishConversion('FORGOT USERNAME OR PASSWORD', 'SPLASH PAGE FORGOT USERNAME OR PASSWORD');

                if ($scope.$parent.previousState && $scope.$parent.previousState.length > 0) {
                    // If user came from a defined previous state, take them back after successful account unlock.
                    $state.go($scope.$parent.previousState, $scope.$parent.previousStateParams);
                } else {
                    location.replace("/member/home")
                }
            };

            var showGeneralErrorMessage = function() {
                $scope.disableSubmitButtons = true;
                $scope.disableButtons = false;
                userService.showFooterMessage($scope.footerMessage, "", "We are having trouble processing your request right now. Try again in a few minutes. " +
                    "If the problem continues, please call the number on the back of your member ID card.", true);
            };

            // Start step 2 conversion event
            coremetrics.startConversion('STEP 2 SELECT USERNAME/PASSWORD/ACCOUNT', 'SPLASH PAGE FORGOT USERNAME OR PASSWORD');
        }
    ]);
};